import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Glyphicon, Nav, Navbar, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import './NavMenu.css';

export class NavMenu extends Component {
  displayName = NavMenu.name

  render() {
    return (
      <Navbar inverse fixedTop fluid collapseOnSelect>
        <Navbar.Header>
          <Navbar.Brand>
            <Link to={'/'}>Пилотный проект</Link>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav>
            <LinkContainer to={'/'} exact>
              <NavItem>
                <Glyphicon glyph='home' /> Главная
              </NavItem>
            </LinkContainer>          
             <LinkContainer to={'/second'}>
                <NavItem>
                <Glyphicon glyph='th-list' /> BERT 
                </NavItem>
             </LinkContainer>
             <LinkContainer to={'/third'}>
               <NavItem>
                 <Glyphicon glyph='th-list' /> Документация
                </NavItem>
             </LinkContainer>         
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NavMenu.js